import { ActionButtons as ActionButtonsComponent } from './ActionButtons.component';
import { connector } from './ActionButtons.connector';

export const ActionButtons = connector(ActionButtonsComponent);
